'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.announcementError = exports.acceptAnnouncement = exports.loadAnnouncements = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doLoadAnnouncements = doLoadAnnouncements;
exports.doAcceptAnnouncement = doAcceptAnnouncement;
exports.watchAnnouncements = watchAnnouncements;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _modals = require('redux/modules/modals');

var _selectors = require('redux/saga/selectors');

var _localStorage = require('redux/saga/helpers/local-storage');

var _helpers = require('redux/saga/helpers');

var _deep = require('helpers/deep');

var _universalLogger = require('universal-logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadAnnouncements),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doAcceptAnnouncement),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchAnnouncements);

var LOAD_TERMS_AND_CONDITIONS = 'LOAD_TERMS_AND_CONDITIONS';
var ACCEPT_TERMS_AND_CONDITIONS = 'ACCEPT_TERMS_AND_CONDITIONS';
var ANNOUNCEMENTS_ERROR = 'ANNOUNCEMENTS_ERROR';

var loadAnnouncements = exports.loadAnnouncements = function loadAnnouncements() {
  return { type: LOAD_TERMS_AND_CONDITIONS };
};
var acceptAnnouncement = exports.acceptAnnouncement = function acceptAnnouncement(referenceHash) {
  return { type: ACCEPT_TERMS_AND_CONDITIONS, referenceHash: referenceHash };
};
var announcementError = exports.announcementError = _helpers.errorActionCreator.bind(null, ANNOUNCEMENTS_ERROR);

function doLoadAnnouncements(client) {
  var _ref, _ref2, path, isUserLoggedIn, unseenAnnouncementsCount, isTermsPages, hasSeenAllAnnouncements, userAnnouncementsList, announcementCount;

  return _regenerator2.default.wrap(function doLoadAnnouncements$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.all)([(0, _effects.select)(_selectors.pathSelector), (0, _effects.select)(_selectors.isLoggedIn), (0, _effects.call)(_localStorage.readSessionStorage, 'unseenAnnouncements')]);

        case 3:
          _ref = _context.sent;
          _ref2 = (0, _slicedToArray3.default)(_ref, 3);
          path = _ref2[0];
          isUserLoggedIn = _ref2[1];
          unseenAnnouncementsCount = _ref2[2];

          // Announcements should not show up on any of the terms pages
          isTermsPages = path.indexOf('/terms') !== -1;
          hasSeenAllAnnouncements = unseenAnnouncementsCount === 0;

          if (!(!isTermsPages && isUserLoggedIn && !hasSeenAllAnnouncements)) {
            _context.next = 20;
            break;
          }

          _context.next = 13;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userAnnouncements, [client]);

        case 13:
          userAnnouncementsList = _context.sent;
          announcementCount = (0, _deep.deepExtract)('announcements.length', userAnnouncementsList, 0);
          // to avoid calling the the api multiple times we store the amount of unseen announcements so that we know if we should call the api the next time.

          _context.next = 17;
          return (0, _effects.call)(_localStorage.writeSessionStorage, 'unseenAnnouncements', announcementCount);

        case 17:
          if (!(announcementCount > 0)) {
            _context.next = 20;
            break;
          }

          _context.next = 20;
          return (0, _effects.put)((0, _modals.showModal)('AnnouncementsModal'));

        case 20:
          _context.next = 26;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context['catch'](0);
          _context.next = 26;
          return (0, _effects.call)(_universalLogger.error, 'Error loading announcements', _context.t0.message);

        case 26:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 22]]);
}

function doAcceptAnnouncement(client, _ref3) {
  var referenceHash = _ref3.referenceHash;
  return _regenerator2.default.wrap(function doAcceptAnnouncement$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.all)([(0, _effects.call)(client.users.claimAnnouncements, [referenceHash], { status: 'consent' }), (0, _effects.put)((0, _modals.hideModal)('AnnouncementsModal'))]);

        case 3:
          _context2.next = 9;
          break;

        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 9;
          return (0, _effects.all)([(0, _effects.call)(_universalLogger.error, 'Error accepting announcement', _context2.t0.message), (0, _effects.put)((0, _modals.hideModal)('AnnouncementsModal'))]);

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 5]]);
}

function watchAnnouncements(client) {
  return _regenerator2.default.wrap(function watchAnnouncements$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_TERMS_AND_CONDITIONS, doLoadAnnouncements, client);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, ACCEPT_TERMS_AND_CONDITIONS, doAcceptAnnouncement, client);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}